let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dT7Bp")).then(() => parcelRequire('5aldt'));